import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SearchOutlined,
  MessageOutlined,
  CarOutlined,
} from '@ant-design/icons';

const STEP_ICONS = [<SearchOutlined key="search" />, <MessageOutlined key="message" />, <CarOutlined key="car" />];
const STEP_KEYS = [
  { titleKey: 'home.how_step1_title', descKey: 'home.how_step1_desc' },
  { titleKey: 'home.how_step2_title', descKey: 'home.how_step2_desc' },
  { titleKey: 'home.how_step3_title', descKey: 'home.how_step3_desc' },
];

const HowItWorks: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="hp-section hp-bg-alt">
      <div className="hp-container">
        <div className="hp-section-header">
          <h2>{t('home.how_title')}</h2>
          <p>{t('home.how_subtitle')}</p>
        </div>
        <div className="row g-4 justify-content-center">
          {STEP_KEYS.map((step, index) => (
            <div key={index} className="col-md-4">
              <div className="text-center p-4">
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'rgba(254, 90, 29, 0.1)',
                    color: '#fe5a1d',
                    fontSize: '2rem',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                  }}
                >
                  {STEP_ICONS[index]}
                </div>
                <h4 className="mb-3">{t(step.titleKey)}</h4>
                <p className="text-muted">{t(step.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
